<template>
  <div>
    <div class="d-flex">
      <div
        @click.stop="onImagePreview"
        class="mr-2"
        style="display: flex;flex-direction: column;align-items: center;"
      >
        <el-image
          style="width: 140px; height: 140px;"
          fit="scale-down"
          :src="
            formData.defaultImageUrl
              ? $osscdn(formData.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width: 140px; height: 140px;"
            />
          </div>
        </el-image>
        <el-button
          type="primary"
          style="width:140px"
          size="mini"
          class="mt-2"
          plain
          v-if="['addSku'].includes(optType)"
          @click.stop="spuImageVisible = true"
        >
          {{ $l('form_label_picture_maintenance') || '图片维护' }}
        </el-button>
      </div>
      <div style="flex:1;">
        <div class="d-flex ml-2 bt-1 bb-1 bl-1">
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_spu_number') || 'SPU number'
            }}</template>
            <template v-slot:value>{{ formData.evgSpuNo }}</template>
          </LabelValue>
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_evgSpuStatus') || 'Status'
            }}</template>
            <template v-slot:value
              ><b-badge
                style="font-size: 12px;padding: 5px 10px;"
                :variant="
                  formData.evgSpuStatus === 'Y'
                    ? 'success'
                    : formData.evgSpuStatus === 'D'
                    ? 'danger'
                    : 'primary'
                "
              >
                {{
                  formData.v_evgSpuStatus ||
                    $l('title_status_planning') ||
                    '企划'
                }}
              </b-badge></template
            >
          </LabelValue>
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_modifyDate') || 'Last update'
            }}</template>
            <template v-slot:value>
              {{ formData.modifyByName ? formData.modifyByName : '--' }} at
              {{ formData.modifyDate ? formData.modifyDate : '--' }}</template
            >
          </LabelValue>
        </div>
        <div class="d-flex ml-2 bb-1 bl-1">
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_goodsName') || 'Chinese name'
            }}</template>
            <template v-slot:value>{{ formData.goodsName }}</template>
          </LabelValue>
        </div>
        <div class="d-flex ml-2 bb-1 bl-1">
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_goodsNameEn') || 'English name'
            }}</template>
            <template v-slot:value>{{ formData.goodsNameEn }}</template>
          </LabelValue>
        </div>
        <div class="d-flex ml-2 bb-1 bl-1">
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_custName') || 'Customer'
            }}</template>
            <template v-slot:value>{{ formData.custName }}</template>
          </LabelValue>
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_brandName') || 'Brand'
            }}</template>
            <template v-slot:value>{{ formData.brandName }}</template>
          </LabelValue>
        </div>
        <div class="d-flex ml-2 bb-1 bl-1">
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_categoryName') || 'Category'
            }}</template>
            <template v-slot:value>{{ formData.categoryFullName }}</template>
          </LabelValue>
          <LabelValue>
            <template v-slot:label>{{
              $l('form_label_sd_collectionName') || 'Collection'
            }}</template>
            <template v-slot:value>{{ formData.collectionName }}</template>
          </LabelValue>
        </div>
      </div>
    </div>
    <SpuImage
      v-if="spuImageVisible"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
      :visible.sync="spuImageVisible"
      :evgSpuCode="evgSpuCode"
      @reload="getData"
    />

    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>

<script>
import SpuImage from '../edit-form/spu-image'
import LabelValue from './label-value.vue'
export default {
  components: { SpuImage, LabelValue },
  props: {
    evgSpuCode: { type: String, default: '' },
    optType: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      spuImageVisible: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.evgSpuCode) return
      this.$api
        .ecomEvgSpuDetailApi({
          evgSpuCode: this.evgSpuCode,
        })
        .then((res) => {
          const data = res.body
          this.formData = { ...data }
          const { evgSpuStatus } = data
          this.$emit('update:evgSpuStatus', evgSpuStatus)
        })
    },
    onImagePreview() {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer

      const index = this.formData.listImageUrl.findIndex(
        (item) => item.displayImageUrl === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-card__body {
    padding: 15px !important;
  }
}
.bt-1 {
  border-top: 1px solid #efefef;
}
.bb-1 {
  border-bottom: 1px solid #efefef;
}
.bl-1 {
  border-left: 1px solid #efefef;
}
.image-col {
  padding: 0;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
